import { useAsyncData, useRoute } from '#imports'

import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useFetchProductSourceUrl } from '~/scopes/product-core/composables/useFetch/useFetchProductSourceUrl/useProductSourceUrl'
import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

export function useFetchArticles() {
  const $httpFetch = useHttpFetch()

  const route = useRoute()
  const { isMasterPPUrl } = useMasterPP()
  const productPageUrl = useFetchProductSourceUrl()

  return useAsyncData(
    async () =>
      await $httpFetch('/internal-links/v1/cards', {
        query: {
          source_url: isMasterPPUrl.value
            ? productPageUrl.value
            : route.fullPath,
        },
        timeout: 500,
      }),
    {
      dedupe: 'defer',
      transform(data): ArticleCard[] {
        const filteredLinkList = data?.linkLists.find(
          (linkList) => linkList.listId === 'pp_cards',
        )

        return (filteredLinkList?.links || [])
          .map((item) => ({
            title: item.title,
            text: item.description,
            id: item.link.href,
            imageSrc: item.image.src,
            link: { href: item.link.relativeHref },
            category: item.tagline,
            ...(item.image.alt ? { imageAlt: item.image.alt } : {}),
          }))
          .filter(
            (item): item is ArticleCard =>
              item.imageSrc !== null &&
              item.title !== null &&
              item.text !== null &&
              item.imageAlt !== null,
          )
      },
    },
  )
}
